import styled from "@emotion/styled";
import { colorPalette } from "../../../theme/colors";
import Box from "../../../primitives/Box/Box";
import ReactPlayer from "react-player";

export const MessageCardContainer = styled.div`
  background-color: ${colorPalette.popWhite[500]};
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
`;

export const StyledImageContainer = styled(Box)`
  aspect-ratio: 1/1;
`;

export const HeaderContainer = styled.div`
  margin-bottom: 12px;
`;

export const ContentContainer = styled.div`
  margin-bottom: 12px;
`;

export const ImageGallery = styled.div`
  display: flex;
  gap: 8px;
  margin: 12px 0;
`;

export const ImageItem = styled.div`
  position: relative;
  border-radius: 8px;
  overflow: hidden;
`;

export const ImageOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
`;

export const ActionButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 12px;
`;

export const ActionButton = styled.button<{
  variant: "primary" | "secondary";
}>`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 8px;
  border: ${(props) =>
    props.variant === "primary"
      ? "none"
      : `1px solid ${colorPalette.popOrange[500]}`};
  background-color: ${(props) =>
    props.variant === "primary"
      ? colorPalette.popOrange[500]
      : colorPalette.popWhite[500]};
  cursor: pointer;
  transition: all 0.2s ease;
  flex: 1;

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`;

export const TimestampContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
`;

export const StyledIcon = styled(Box)`
  transform: translate(-50%, -50%);
`;

export const StyledVideo = styled.video<{ isFullscreen: boolean }>`
  width: 100%;
  height: 100%;
  object-fit: ${(props) =>
    props.isFullscreen ? "contain" : "cover"} !important;
  border-radius: 4px;
  border: 1px solid ${colorPalette.popBlack[500]};

  /*iOS Safari specific fixes */
  -webkit-playsinline: true;
  playsinline: true;
  webkit-playsinline: true;

  /* Better video loading */
  preload: metadata;

  /*iOS Safari video controls */
  -webkit-media-controls: true;
  -webkit-media-controls-panel: true;
  -webkit-media-controls-play-button: true;
  -webkit-media-controls-start-playback-button: true;

  /* Force object-fit with !important for iOS Safari */
  -webkit-object-fit: ${(props) =>
    props.isFullscreen ? "contain" : "cover"} !important;
  -moz-object-fit: ${(props) =>
    props.isFullscreen ? "contain" : "cover"} !important;
  -ms-object-fit: ${(props) =>
    props.isFullscreen ? "contain" : "cover"} !important;

  /*iOS Safari specific video styling */
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;

  /* Force hardware acceleration for iOS */
  -webkit-perspective: 1000;
  perspective: 1000;
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;

  /* Force video to show first frame */
  background-color: ${colorPalette.popWhite[100]};

  /* iOS Safari specific fixes */
  -webkit-appearance: none;
  appearance: none;

  /* Ensure poster is displayed immediately */
  &[poster] {
    background-image: attr(poster);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
`;

// In MessageCard.styles.ts, update the StyledReactPlayer:

export const StyledReactPlayer = styled(ReactPlayer)`
  width: 100% !important;
  height: 100% !important;

  video {
    width: 100% !important;
    height: 100% !important;
    object-fit: ${(props) =>
      props.isFullscreen ? "contain" : "cover"} !important;
    border-radius: 4px;
    border: 1px solid ${colorPalette.popBlack[500]};

    /* iOS Safari specific fixes */
    -webkit-playsinline: true;
    playsinline: true;
    webkit-playsinline: true;

    /* Better video loading */
    preload: metadata;

    /* iOS Safari video controls */
    -webkit-media-controls: true;
    -webkit-media-controls-panel: true;
    -webkit-media-controls-play-button: true;
    -webkit-media-controls-start-playback-button: true;

    /* Force object-fit with !important for iOS Safari */
    -webkit-object-fit: ${(props) =>
      props.isFullscreen ? "contain" : "cover"} !important;
    -moz-object-fit: ${(props) =>
      props.isFullscreen ? "contain" : "cover"} !important;
    -ms-object-fit: ${(props) =>
      props.isFullscreen ? "contain" : "cover"} !important;

    /* iOS Safari specific video styling */
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;

    /* Force hardware acceleration for iOS */
    -webkit-perspective: 1000;
    perspective: 1000;
    -webkit-transform-style: preserve-3d;
    transform-style: preserve-3d;

    /* Force video to show first frame */
    background-color: ${colorPalette.popWhite[100]};

    /* iOS Safari specific fixes */
    -webkit-appearance: none;
    appearance: none;
  }

  /* ReactPlayer specific styling */
  .react-player__preview {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    border-radius: 4px;
  }

  .react-player__shadow {
    display: none !important;
  }
`;
